import axios from 'axios'

import ee from '../ee'

class NewsletterSignupForm {
  constructor(el) {
    this.el = el
    this.formEl = this.el.querySelector('.js-newsletter-signup-form__form')
    this.errorMessageEl = this.el.querySelector(
      '.js-newsletter-signup-form-error'
    )
    this.addEventListeners()
  }

  addEventListeners() {
    this.el.addEventListener('submit', (e) => {
      e.preventDefault()
      this.sendData()
    })
  }

  sendData() {
    let formData = new FormData(this.formEl)

    if (this.validateEmailAddress(this.formEl.email.value)) {
      axios
        .post('/', formData, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (response.data && response.data.errorCode === 200) {
            this.errorMessageEl.classList.add('hidden')
            this.el.innerHTML = 'Thanks for subscribing!'
          } else {
            this.showErrorMsg(
              'Sorry, there was an error. Please try again later.'
            )
          }
        })
        .catch(() => {
          this.showErrorMsg(
            'Sorry, there was an error. Please try again later.'
          )
        })
    } else {
      this.showErrorMsg('Please provide a valid e-mail address.')
    }
  }

  showErrorMsg(message) {
    this.errorMessageEl.classList.remove('hidden')
    this.errorMessageEl.innerHTML = message
  }

  validateEmailAddress(email) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
  }
}

function init() {
  const newsletterSignupFormEls = document.querySelectorAll(
    '.js-newsletter-signup-form'
  )

  Array.from(newsletterSignupFormEls).forEach((el) => {
    new NewsletterSignupForm(el)
  })
}

ee.addListener('initComponents', init)
